import { ListAlt } from '@mui/icons-material'
import LocationSectionCreate from './LocationSectionCreate'
import LocationSectionEdit from './LocationSectionEdit'
import LocationSectionList from './LocationSectionList'

const locationSectionIndex = {
  icon: ListAlt,
  list: LocationSectionList,
  edit: LocationSectionEdit,
  create: LocationSectionCreate,
}

export default locationSectionIndex
